var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_c('pipeline-validation-monitor'),_c('out-of-boundaries-monitor'),_c('product-not-printable-monitor'),_c('small-details-monitor')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }